module.exports = __webpack_public_path__ + "static/image/font/pc/kkubulim-3.ver2_0_2.png?faff8813";